import React, { createContext, useContext, useState, useEffect } from 'react';

// Simple admin authentication for El Bethel Ministries
const ADMIN_CREDENTIALS = {
  email: 'admin@elbethel.online',
  password: 'ElBethel2024!'  // You can change this
};

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing auth on page load
    const savedAuth = localStorage.getItem('elbethel_admin_auth');
    if (savedAuth) {
      try {
        const authData = JSON.parse(savedAuth);
        setUser(authData);
      } catch (error) {
        localStorage.removeItem('elbethel_admin_auth');
      }
    }
    setLoading(false);
  }, []);

  const signIn = async (email, password) => {
    try {
      // Simple credential check
      if (email === ADMIN_CREDENTIALS.email && password === ADMIN_CREDENTIALS.password) {
        const user = {
          id: 'admin-1',
          email: email,
          primaryEmail: email,
          displayName: 'El Bethel Admin',
          signedInAt: new Date().toISOString()
        };
        
        setUser(user);
        localStorage.setItem('elbethel_admin_auth', JSON.stringify(user));
        
        return { success: true };
      } else {
        return { success: false, error: 'Invalid email or password' };
      }
    } catch (error) {
      return { success: false, error: 'Authentication failed' };
    }
  };

  const signOut = async () => {
    try {
      setUser(null);
      localStorage.removeItem('elbethel_admin_auth');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  const value = {
    user,
    loading,
    signIn,
    signOut,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};